import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community';
import { ButtonRendererComponent } from 'src/app/button-renderer.component';
import { Button3RendererComponent } from 'src/app/button3-renderer.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as $ from 'jquery';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-mydashboard',
  templateUrl: './mydashboard.component.html',
  styleUrls: ['./mydashboard.component.css']
})
export class MydashboardComponent implements OnInit {
  //evaluationData : Vendordata;
  ID: string;
  filename: string;
  addCommentBoolVN: boolean = false;

  addCommentBool1: boolean = false;
  addCommentBool2: boolean = false;
  addCommentBool3: boolean = false;
  addCommentBool4: boolean = false;
  ProjectName: string;
  ClientName: string;
  ProjectDescription: string;
  data: Vendordata;
  evaluationDataAny: any;
  PurchaseOrderData: any;
  NewVendors: any;
  MessageCount: any;
  dataNew: any;
  myDashboardProjectID: string;
  count: number;
  rowData: any;
  rowDataNew: any;
  rowDataNew1: any;
  errorLogData: any;
  pagination = true;
  paginationPageSize = 15;
  addCommentBool: boolean = false;
  dataLog: any;
  dataSubmitAnswer: any;
  private gridApi;
  private gridColumnApi;
  columnDefs = [
    { headerName: '', field: '', width: 50, headerCheckboxSelection: true, checkboxSelection: true, minWidth: 40 },
    {
      headerName: 'Actions',
      minWidth: 150,
      cellRenderer: 'button3Renderer',
      resizable: true,
      filter: true, sortable: true,
      cellRendererParams: {
        onClick: this.actionClick.bind(this),
      },
    },
    { headerName: "Project ID", field: "projectID", filter: true, sortable: true, resizable: true },
    { headerName: "Project", field: "projectName", filter: true, sortable: true, resizable: true },
    { headerName: "Client", field: "clientName", filter: true, sortable: true, resizable: true },
    { headerName: "Mode", field: "projectMode", filter: true, sortable: true, resizable: true },
    { headerName: "Actual Target", field: "target", filter: true, sortable: true, resizable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", filter: true, sortable: true, resizable: true },
    { headerName: "Overall Target", field: "totalTarget", filter: true, sortable: true, resizable: true },
    { headerName: "Completes", field: "totalComplete", filter: true, sortable: true, resizable: true },
    { headerName: "Left Over", field: "leftOver", filter: true, sortable: true, resizable: true },
    { headerName: "In Progress", field: "inprogress", filter: true, sortable: true, resizable: true },
    { headerName: "Incident Rate(%)", field: "incidentRate", filter: true, sortable: true, resizable: true },
    { headerName: "Terminate", field: "totalTerminate", filter: true, sortable: true, resizable: true },
    { headerName: "Quota Full", field: "totalQuotaFull", filter: true, sortable: true, resizable: true },
    { headerName: "QC Reject", field: "totalQCReject", filter: true, sortable: true, resizable: true },
    {
      headerName: 'Delete',
      cellRenderer: 'buttonRenderer',
      cellRendererParams: {
        onClick: this.deleteProject.bind(this),
        label: 'Delete'
      },
    },

  ];

  columnDefsNew = [
    { headerName: "Country Name", field: "country", filter: true, sortable: true, resizable: true },
    { headerName: "Language", field: "language", filter: true, sortable: true, resizable: true },
    { headerName: "Vendor Name", field: "vendorName", filter: true, sortable: true, resizable: true },
    { headerName: "Assigned Clip(s)", field: "clip", filter: true, sortable: true, resizable: true },
    // {
    //   headerName: "Vendor Name",
    //   field: "vendorName",
    //   filter: true,
    //   sortable: true,
    //   resizable: true,
    //   cellRenderer: (params: any) => {
    //     if (!params.value) return '';
    //     return `<a href="javascript:void(0)" class="vendor-link">${params.value}</a>`;
    //   },
    //   onCellClicked: () => {
    //     this.openVendorPopup(); // 👈 just open modal, no parameter
    //   }
    // },
    { headerName: "Actual Target", field: "target", filter: true, sortable: true, resizable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", filter: true, sortable: true, resizable: true },
    { headerName: "Overall Target", field: "totalTarget", filter: true, sortable: true, resizable: true },
    { headerName: "Complete", field: "totalComplete", filter: true, sortable: true, resizable: true },
    { headerName: "Left Over", field: "leftOver", filter: true, sortable: true, resizable: true },
    { headerName: "InProgress", field: "inProgress", filter: true, sortable: true, resizable: true },
    { headerName: "Incident Rate", field: "incidentRate", filter: true, sortable: true, resizable: true },
    { headerName: "Terminate", field: "totalTerminate", filter: true, sortable: true, resizable: true },
    { headerName: "Quota Full", field: "totalQuotaFull", filter: true, sortable: true, resizable: true },
    { headerName: "QC Reject", field: "totalQCReject", filter: true, sortable: true, resizable: true },

  ];

  openVendorPopup() {
    this.addCommentBoolVN = true;
    // Show modal manually by setting display style
    const modal = document.getElementById('myModalVendorName');
    if (modal) {
      modal.style.display = 'block';
      modal.classList.add('show');
    }
  }

  closeVendorDialog() {
    const modal = document.getElementById('myModalVendorName');
    if (modal) {
      modal.style.display = 'none';
      modal.classList.remove('show');
    }
  }

  columnDefsNew1 = [
    { headerName: "Project Mode", field: "projectMode", filter: true, sortable: true, resizable: true },
    { headerName: "Finger Print", field: "isFingerPrintEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "IP Security", field: "isIPEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "GEO IP Locaion", field: "isGeoIPLocationEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "Custom Page", field: "isCustomPageEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "Captcha", field: "isCaptcha", filter: true, sortable: true, resizable: true },
    { headerName: "Questionnaire", field: "isQuestionnaire", filter: true, sortable: true, resizable: true },
    { headerName: "Device", field: "isMobile", filter: true, sortable: true, resizable: true },

    { headerName: "RD Check", field: "isRDEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "Activity", field: "isActivityEnabled", filter: true, sortable: true, resizable: true },

    //{ headerName: "Custom Page Message", field: "customPageMessage", filter: true, sortable: true,resizable: true},
    { headerName: "Update On", field: "updateOn", filter: true, sortable: true, resizable: true },
    { headerName: "Updated By", field: "updatedBy", filter: true, sortable: true, resizable: true },
  ];

  columnDefsNew2 = [
    { headerName: "Question", width: 150, field: "question", filter: true, sortable: true, resizable: true },
    { headerName: "Correct Answer", width: 100, field: "correctAnswer", filter: true, sortable: true, resizable: true },
    { headerName: "Submit Answer", width: 100, field: "submitAnswer", filter: true, sortable: true, resizable: true },
    { headerName: "Is Correct", width: 80, field: "isCorrect", filter: true, sortable: true, resizable: true },
    { headerName: "Vendor Name", width: 100, field: "vendorName", filter: true, sortable: true, resizable: true },
    { headerName: "Country Name", width: 100, field: "countryName", filter: true, sortable: true, resizable: true },
    { headerName: "Language", width: 50, field: "language", filter: true, sortable: true, resizable: true },
    { headerName: "Created Date", width: 250, field: "createdDate", filter: true, sortable: true, resizable: true },
  ];

  columnDefsErrorLogs = [
    { headerName: "Project Id", width: 50, field: "projectId", filter: true, sortable: true, resizable: true },
    { headerName: "Country", width: 30, field: "countryName", filter: true, sortable: true, resizable: true },
    { headerName: "Language", width: 30, field: "languageName", filter: true, sortable: true, resizable: true },
    { headerName: "Error Message", width: 350, field: "errorMessage", filter: true, sortable: true, resizable: true },
    { headerName: "URL Entered", width: 550, field: "url", filter: true, sortable: true, resizable: true },
    { headerName: "Created Date", width: 200, field: "createdDate", filter: true, sortable: true, resizable: true },

  ];

  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };
  defaultColDefForLogs = {
    minWidth: 100,
  };
  rowSelection = 'multiple';
  frameworkComponents: any;
  modalRef: BsModalRef;

  constructor(private router: Router, private modalService: BsModalService, private userService: UserService, private toastr: ToastrService,
    private dataSharingService: DataSharingService, private evaluationService: EvaluationService, private adminDashboardService: AdmindashboardService) {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
      button3Renderer: Button3RendererComponent,
    }
  }

  ngOnInit() {
    debugger;
    this.adminDashboardService.getPurchaseOrders().subscribe(
      (data) => {
        this.PurchaseOrderData = data;
        console.log(this.PurchaseOrderData);
      }
    )
    this.adminDashboardService.getNewVendors().subscribe(
      (data) => {
        this.NewVendors = data;
        console.log(this.NewVendors);
      }
    )
    this.adminDashboardService.getMessageCount().subscribe(
      (data) => {
        this.MessageCount = data;
        console.log("Message count" + this.MessageCount);
      }
    )


    this.evaluationService.getAllVendorsForEvaluation().subscribe(
      (data) => {
        this.evaluationDataAny = data;
        for (var i = 0; i < this.evaluationDataAny.length; i++) {
          this.evaluationDataAny[i].leftOver = this.evaluationDataAny[i].totalTarget - this.evaluationDataAny[i].totalComplete - this.evaluationDataAny[i].optimisticCount
        }
        //this.evaluationData = this.evaluationDataAny;
        this.data = this.evaluationDataAny;
        this.rowData = this.data;
      }
    )



  }
  searchProject(keyword) {
    this.userService.searchProject(keyword).subscribe(
      (data) => {
        this.dataNew = data;
        for (var i = 0; i < this.dataNew.length; i++) {
          this.dataNew[i].leftOver = this.dataNew[i].totalTarget - this.dataNew[i].totalComplete - this.dataNew[i].optimisticCount
        }
        this.data = this.dataNew;
        this.rowData = this.dataNew;
      }
    );
  }

  deleteProject(params) {
    debugger;
    var result = confirm("Are you sure you want to delete ?");
    if (result) {
      this.userService.deleteProject(params.data.projectID).subscribe(
        (data) => {
          if (data == true) {
            this.toastr.success("Project Deleted Successfully", '', { progressBar: true });
            this.evaluationService.getAllVendorsForEvaluation().subscribe(
              (data) => {
                this.evaluationDataAny = data;
                for (var i = 0; i < this.evaluationDataAny.length; i++) {
                  this.evaluationDataAny[i].leftOver = this.evaluationDataAny[i].totalTarget - this.evaluationDataAny[i].totalComplete - this.evaluationDataAny[i].optimisticCount
                }
                //this.evaluationData = this.evaluationDataAny;
                this.data = this.evaluationDataAny;
                this.rowData = this.evaluationDataAny;
                console.log(this.data);
              }
            )
          }
          else {

          }
        }
      )
    }
  }

  moveToDashboard(data) {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    //alert(selectedNodes[0].data.projectID);
    this.myDashboardProjectID = "";
    for (let item of selectedNodes) {
      this.myDashboardProjectID += item.data.projectID + ",";
    }
    //console.log("hello",this.myDashboardProjectID);
    debugger;
    if (selectedNodes.length > 0) {
      this.myDashboardProjectID = this.myDashboardProjectID.substring(0, this.myDashboardProjectID.length - 1);
      this.moveProjectDetailToDashboard(this.myDashboardProjectID, data);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  moveProjectDetailToDashboard(myDashboardProjectID, datanew) {
    debugger;
    this.userService.moveProjectDetailToDashboard(myDashboardProjectID).subscribe(
      (data) => {
        if (data == true) {
          this.gridApi.deselectAll();
          this.toastr.success("Successfully Moved", '', { progressBar: true });
        }
        else {
          this.toastr.error("Some Error Occur", '', { progressBar: true });
          this.gridApi.deselectAll();
        }
      }
    );
  }

  onGridReady(params) {
    debugger
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onBtnExport() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0) {
      var params = {
        onlySelected: true,
      };
      this.gridApi.exportDataAsCsv(params);
      this.gridApi.deselectAll();
    }

    else {
      this.toastr.warning("Select atleast one checkbox to export", '', { progressBar: true });
    }
  }

  actionClick(param) {
    debugger;
    var id = param.event.srcElement['id'];
    var projectId = param.rowData.projectID;
    var projectname = param.rowData.projectName;
    var clientname = param.rowData.clientName;
    var projectdesc = param.rowData.projectDescription;
    if (id == "view") {
      this.router.navigate(['/viewprojectdetails/' + projectId]);
    }
    else if (id == "addcomment") {
      this.addCommentBool = true;
      this.addCommentBool1 = false;
      this.addCommentBool2 = false;
      this.addCommentBool3 = false;
      this.addCommentBool4 = false;

      this.ID = projectId;
      $("#Modal").css("width", "77%");
      $("#myModal").show();
    }
    else if (id == "projectinfo") {
      this.addCommentBool = false;
      this.addCommentBool1 = true;
      this.addCommentBool2 = false;
      this.addCommentBool3 = false;
      this.addCommentBool4 = false;

      this.ID = projectId;
      this.ProjectName = projectname;
      this.ClientName = clientname;
      this.ProjectDescription = projectdesc;
      this.userService.getProjectCalculationDetails(this.ID).subscribe(
        (data) => {
          if (data != null) {
            // console.log(data);
            this.rowDataNew = data;
            for (var i = 0; i < this.rowDataNew.length; i++) {
              this.rowDataNew[i].leftOver = this.rowDataNew[i].totalTarget - this.rowDataNew[i].totalComplete - this.rowDataNew[i].optimisticCount
            }
          }
          else {
            this.rowDataNew = "";
          }
        }
      );
      $("#Modal").css("width", "140%");
      $("#myModal").show();
    }
    else if (id == "projectlog") {
      this.addCommentBool = false;
      this.addCommentBool1 = false;
      this.addCommentBool2 = true;
      this.addCommentBool3 = false;
      this.addCommentBool4 = false;

      this.ID = projectId;
      this.ProjectName = projectname;
      this.ClientName = clientname;
      this.ProjectDescription = projectdesc;
      this.userService.getProjectLog(this.ID).subscribe(
        (data) => {
          console.log(data);
          if (data != null && data != undefined) {
            this.dataLog = data;
            // for(var i =0; i<this.dataLog.length; i++)
            // {
            //   this.dataLog[i].customPageMessage = data[i].customPageMessage.replace(/<[^>]*>/g, '');
            // }
            // this.rowDataNew1 = this.dataLog;
            for (var i = 0; i < this.dataLog.length; i++) {
              if (this.dataLog[i].isMobile == 0) {
                this.dataLog[i].isMobile = "Desktop"
              }
              else if (this.dataLog[i].isMobile == 1) {
                this.dataLog[i].isMobile = "Mobile"
              }
              else if (this.dataLog[i].isMobile == 2) {
                this.dataLog[i].isMobile = "Both"
              }
            }
            this.rowDataNew1 = this.dataLog;

          }
          else {
            this.rowDataNew1 = "";
          }
        });
      $("#Modal").css("width", "140%");
      $("#myModal").show();
    } else if (id == "answersInfo") {
      this.addCommentBool = false;
      this.addCommentBool1 = false;
      this.addCommentBool2 = false;
      this.addCommentBool3 = true;
      this.addCommentBool4 = false;

      this.ID = projectId;
      this.ProjectName = projectname;
      this.ClientName = clientname;
      this.ProjectDescription = projectdesc;
      this.userService.getSubmitAnswers(this.ID).subscribe(
        (data) => {
          console.log(data);
          if (data != null && data != undefined) {
            this.rowDataNew1 = data;
          }
          else {
            this.rowDataNew1 = "";
          }
        });
      $("#Modal").css("width", "140%");
      $("#myModal").show();
    }
    else if (id == "errorLogs") {
      this.addCommentBool = false;
      this.addCommentBool1 = false;
      this.addCommentBool2 = false;
      this.addCommentBool3 = false;
      this.addCommentBool4 = true;
      this.ID = projectId;
      this.ProjectName = projectname;
      this.ClientName = clientname;
      this.ProjectDescription = projectdesc;
      this.userService.getClientSurveyErrorLogs(this.ID).subscribe(
        (data) => {
          debugger
          if (data != null && data != undefined) {
            this.errorLogData = data
          }
          else {
            this.errorLogData = "";
          }
        })
      $("#Modal").css("width", "140%");
      $("#myModal").show();
    }
  }

  closeDialog() {
    $("#myModal").hide();
  }

  onGridDataExport() {
    this.gridApi.exportDataAsCsv();
    this.gridApi.deselectAll();
  }

  onPreScreenAnswerDataExport(message: string) {
    debugger
    if (message == 'Exporting logs') {
      this.filename = 'Client_Survey_Error_Logs'
    }
    else {
      this.filename = "PreScreening_Answers"
    }

    const rowData: any[] = [];
    this.gridApi.forEachNode(node => rowData.push(node.data));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
    const headers = Object.keys(rowData[0] || {});

    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_col(index) + "1";
      if (!worksheet[cellAddress]) return;

      worksheet[cellAddress].v = this.capitalizeFirstLetter(header);
      worksheet[cellAddress].s = {
        font: { bold: true },
        alignment: { horizontal: "center" }
      };
    });


    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, this.filename);
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    fileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
